<app-sub-navbar></app-sub-navbar>

<!-- Content -->

<section class="container-fluid my-md-4 bd-layout">
  <aside class="bd-sidebar">
    <nav class="collapse bd-links" id="filterz" aria-label="filterz">
      <ul class="list-unstyled mb-0 py-3 pt-md-1">
        <li class="mb-1">
          <a
            routerLink="/profile"
            class="btn d-inline-flex align-items-center rounded"
          >
            Profile
          </a>
        </li>

        <li class="mb-1">
          <a
            routerLink="/downloads"
            class="btn d-inline-flex align-items-center rounded"
          >
            Downloads
          </a>
        </li>

        <li class="mb-1">
          <a
            routerLink="/favorites"
            class="btn d-inline-flex align-items-center rounded"
          >
            Favorites
          </a>
        </li>

        <li class="mb-1">
          <a
            routerLink="/subscription"
            class="btn d-inline-flex align-items-center rounded"
          >
            Subscription
          </a>
        </li>
      </ul>
    </nav>
  </aside>

  <div class="container-fluid overflow-hidden">
    <div class="row">
      <div class="justify-content-between d-flex">
        <h3 class="fw-bold">Subscription</h3>
        <button
          class="btn bd-sidebar-toggle d-md-none py-0 px-1 ms-3 order-3 collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#filterz"
          aria-controls="filterz"
          aria-expanded="false"
          aria-label="Toggle docs navigation"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            class="bi bi-expand"
            viewBox="0 0 16 16"
          >
            <title>Expand</title>
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10z"
            />
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            class="bi bi-collapse"
            viewBox="0 0 16 16"
          >
            <title>Collapse</title>
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0zm-.5 11.707l-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793z"
            />
          </svg>
        </button>
      </div>
    </div>
    
    <div class="py-3 justify-content-center" *ngIf="!user?.isSubscribed">
      <div class="col-md-12 col-lg-10">
        <h3 class="fs-5 mb-3">Plan</h3>
        <div class="card rounded-4">
          <div class="card-body d-flex justify-content-between">
            <h4 class="card-title my-auto">Free</h4>
            <a routerLink="/pricing" class="btn btn-ib-primary rounded-3">Upgrade Pro</a>
          </div>
        </div>
      </div>
    </div>

    <div class="py-3 justify-content-center" *ngIf="user?.isSubscribed">
      <div class="col-md-12 col-lg-10">
        <h3 class="fs-5 mb-3">Plan</h3>
        <div class="card rounded-4">
          <div class="card-body d-flex flex-column gap-2 justify-content-start">
            <span class="d-flex flex-row gap-2" style="font-size: 1rem">
              Plan Name:
              <h4 class="card-title my-auto" style="font-size: 1rem">Pro</h4>
            </span>
            <span class="d-flex flex-row gap-2" style="font-size: 1rem">
              Subscription Start:
              <h4 class="card-title my-auto" style="font-size: 1rem">
                {{ user?.subscriptionFrom | date : "dd-MMM-yyyy" }}
              </h4>
            </span>
            <span class="d-flex flex-row gap-2" style="font-size: 1rem">
              Subscription End:
              <h4 class="card-title my-auto" style="font-size: 1rem">
                {{ user?.subscriptionTo | date : "dd-MMM-yyyy" }}
              </h4>
            </span>
            <span class="d-flex flex-row gap-2" style="font-size: 1rem">
              Expiry Date:
              <h4 class="card-title my-auto" style="font-size: 1rem">
                {{ user?.expiryDate | date : "dd-MMM-yyyy" }}
              </h4>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
